export default __webpack_public_path__ + "30f0365.png";